var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00838F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_308_6546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0013,
    cy: 20,
    r: 17.3333,
    fill: "url(#paint0_linear_308_6546)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_308_6546)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_6546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.62 5.87063C11.6198 5.60261 10.5917 6.19621 10.3237 7.19646L5.2206 26.2413C4.95259 27.2415 5.54618 28.2697 6.54643 28.5377L35.3793 36.2634C36.3796 36.5315 37.4077 35.9379 37.6757 34.9376L42.7788 15.8928C43.0468 14.8925 42.4532 13.8644 41.4529 13.5964L12.62 5.87063Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 9.91016,
    y: 8.73352,
    width: 33.6,
    height: 4,
    transform: "rotate(15 9.91016 8.73352)",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_6546)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_308_6546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 16.0001C4.97618 16.0001 4.13672 16.8395 4.13672 17.8751V37.5917C4.13672 38.6273 4.97618 39.4667 6.01172 39.4667H35.8617C36.8973 39.4667 37.7367 38.6273 37.7367 37.5917V17.8751C37.7367 16.8395 36.8973 16.0001 35.8617 16.0001H6.01172Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.2421 22.912L24.3221 23.6427C24.0021 23.7529 23.5879 23.808 23.0794 23.808C22.4892 23.808 22.0732 23.6658 21.8314 23.3813C21.5896 23.0969 21.4688 22.6044 21.4688 21.904C21.4688 21.2036 21.5896 20.7111 21.8314 20.4267C22.0732 20.1422 22.4892 20 23.0794 20C23.5274 20 23.915 20.0444 24.2421 20.1333L24.1674 20.8693C23.8047 20.8587 23.4421 20.8533 23.0794 20.8533C22.859 20.8533 22.7096 20.9262 22.6314 21.072C22.5567 21.2142 22.5194 21.4916 22.5194 21.904C22.5194 22.3164 22.5567 22.5956 22.6314 22.7413C22.7096 22.8836 22.859 22.9547 23.0794 22.9547C23.595 22.9547 23.9825 22.9404 24.2421 22.912Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7845 22.8693H25.6538L25.4352 23.744H24.4112L25.4192 20.3253C25.4369 20.2471 25.4761 20.1849 25.5365 20.1387C25.6005 20.0889 25.6734 20.064 25.7552 20.064H26.6832C26.7649 20.064 26.8361 20.0889 26.8965 20.1387C26.9605 20.1849 27.0032 20.2471 27.0245 20.3253L28.0272 23.744H27.0032L26.7845 22.8693ZM26.5978 22.144L26.3632 21.2C26.3241 21.0151 26.3009 20.8871 26.2938 20.816H26.1498C26.1249 20.9511 26.1001 21.0791 26.0752 21.2L25.8405 22.144H26.5978Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.419 23.744H30.3683L30.107 22.6347C30.0821 22.528 30.043 22.4551 29.9897 22.416C29.9399 22.3769 29.8634 22.3573 29.7603 22.3573H29.307V23.744H28.3203V20.064C28.6688 20.0284 29.1648 20.0107 29.8083 20.0107C30.3381 20.0107 30.715 20.0924 30.939 20.256C31.163 20.416 31.275 20.704 31.275 21.12C31.275 21.6604 31.0332 21.9573 30.5497 22.0107V22.0427C30.859 22.0924 31.0474 22.2809 31.115 22.608L31.419 23.744ZM29.307 21.6267H29.787C29.9754 21.6267 30.1017 21.5964 30.1657 21.536C30.2332 21.4756 30.267 21.3582 30.267 21.184C30.267 21.0098 30.2332 20.8924 30.1657 20.832C30.1017 20.7716 29.9754 20.7413 29.787 20.7413H29.307V21.6267Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8464 23.744V20.064C32.4437 20.0284 32.9468 20.0107 33.3557 20.0107C33.9744 20.0107 34.4028 20.144 34.641 20.4107C34.8828 20.6773 35.0037 21.1751 35.0037 21.904C35.0037 22.6329 34.8828 23.1307 34.641 23.3973C34.4028 23.664 33.9744 23.7973 33.3557 23.7973C32.8402 23.7973 32.337 23.7796 31.8464 23.744ZM32.849 20.7627V23.04C32.9522 23.0436 33.121 23.0453 33.3557 23.0453C33.5868 23.0453 33.7433 22.9689 33.825 22.816C33.9068 22.6596 33.9477 22.3556 33.9477 21.904C33.9477 21.4524 33.9068 21.1484 33.825 20.992C33.7433 20.8356 33.5868 20.7573 33.3557 20.7573L32.849 20.7627Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.80469,
    y: 18.6667,
    width: 8.53333,
    height: 5.86667,
    rx: 2.93333,
    fill: "#F9C21B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.47266,
    y: 18.6667,
    width: 0.533334,
    height: 5.86667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0039,
    y: 20.2667,
    width: 5.33333,
    height: 0.266666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.80469,
    y: 21.3333,
    width: 2.66667,
    height: 0.266666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0039,
    y: 22.6666,
    width: 5.33333,
    height: 0.266666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.80469,
    y: 32.2667,
    width: 13.3333,
    height: 2.13334,
    fill: "#BAC4CF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_6546",
    x: -0.84375,
    y: 1.80627,
    width: 53.6875,
    height: 46.5215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_6546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_6546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_6546",
    x: -3.86328,
    y: 9.00006,
    width: 53.6016,
    height: 43.4667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.262745 0 0 0 0 0.466667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_6546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_6546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_308_6546",
    x: -1.86328,
    y: 12.0001,
    width: 49.6016,
    height: 39.4667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_6546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_6546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_6546",
    x1: 20.0013,
    y1: 2.66669,
    x2: 20.0013,
    y2: 37.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D30D0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.1a7bfaed696c390f7d925fde4355ef98.svg";
export { ForwardRef as ReactComponent };